import React,{Component} from 'react';
import './AdminLocationsEdit.css';
import AdminHeaderTool from '../Components/AdminHeaderTool/AdminHeaderTool';
import NabarAdmin from '../Components/NabarAdmin/NabarAdmin';
import AdminTableDetails from '../Components/AdminTableDetails/AdminTableDetails';
import AdminEditLocations from '../Components/AdminEditLocations/AdminEditLocations';
import iconlocationsm from '../../../image/iconlocationsm.svg'
import plusicon from '../../../image/plusicon.svg'
import {Link} from 'react-router-dom';


class AdminLocationsEdit extends Component{
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            search:'',

        }
       
    }
    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };
    render(){
        return(
            <div>
                <div className="row  AppEN mx-0">
                    <div className="col-md-1 px-0 ">
                        <NabarAdmin />
                    </div>
                    <div className=" AdminLocationsEdit Admin col-md-11 px-4">
                    <AdminHeaderTool/>
                        <h3 className=" fontsize9 my-0 order-8 order-md-2">Locations</h3>
                    <div className="row">
                            <div className="col-md-4 px-2 py-3 order-8 order-md-2">
                            <AdminTableDetails icon={iconlocationsm} state={this.state} handleChange={this.handleChange}/>
                                   <div className="createDiv p-2 text-center">
                                        <Link to="/Admin/locations"><button className="text-white badge-pill p-2 pl-1 px-4 border shadow bluebg text-center "><img className="mr-2 " src={plusicon} alt="CREATE" />CREATE</button>
                                        </Link>
                                </div>
                            </div>
                            <div className="col-md-8 px-4 py-3 order-5"> 
                                    <div className="picbg">
                                        <AdminEditLocations/>
                                    </div>
                            </div>
                            </div>

                    </div>
                </div>

            </div>
        )
    }
}
export default AdminLocationsEdit;